import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "Mail__row-content" }
const _hoisted_2 = { key: 0 }

import { PropType } from "vue";
import { Employee, Mail } from "@/types";
import InnSelect from "@/components/ds/select/Select.vue";
import { useEmployeeStore } from "@/stores/employees";


export default /*#__PURE__*/_defineComponent({
  __name: 'MailSender',
  props: {
    mail: {
        type: Object as PropType<Mail>,
        required: true,
    },
    employee: {
        type: Object as PropType<Employee>,
        required: false,
        default: null,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "Mail__label" }, "Van", -1)),
    _createElementVNode("div", _hoisted_1, [
      (__props.employee)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.employee.email), 1))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})